export const GET_BEAMS = 'GET_BEAMS';
export const BEAM_REQUEST = 'BEAM_REQUEST';
export const CREATE_BEAM = 'CREATE_BEAM';
export const UPDATE_BEAM = 'UPDATE_BEAM';
export const DELETE_BEAM = 'DELETE_BEAM';
export const BEAM_REQUEST_FAILURE = 'BEAM_REQUEST_FAILURE';
export const GET_BEAMS_WITH_DETAIL = 'GET_BEAMS_WITH_DETAIL';